var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g, _path22, _path23, _path24, _g2, _path25, _path26, _path27, _g3, _path28, _path29, _path30, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgQrMobileKit = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 168,
    viewBox: "0 0 234 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232.645 46.6155C232.478 44.5099 227.795 43.9877 225.767 40.8877C225.128 39.9155 224.961 38.321 224.961 36.5766C224.961 35.0544 225.083 33.4266 225.139 31.9988C225.272 28.6544 225.133 26.8155 225.167 21.1599C225.195 16.671 224.639 11.6933 222.572 10.5266C220.656 9.43771 217.561 11.5544 213.167 15.5933C210.717 17.8488 209.106 19.7933 207.428 21.1822C207.328 21.2655 207.228 21.3544 207.122 21.4377C207.022 21.5155 204.506 20.8655 203.033 20.571C202.717 20.5099 202.522 20.1377 202.361 19.4822C202.006 18.0099 201.817 15.0766 200.789 10.7877C199.511 5.44883 197.778 2.83771 195.272 2.62104C193.161 2.44326 189.5 7.75993 186.678 12.2099C184.339 15.8933 184.167 16.271 183.256 17.5988C182.589 18.5655 181.828 19.7099 181 20.8599C179.295 23.2266 177.328 25.5877 175.445 26.3377C171.889 27.7488 169.145 25.8488 167.822 27.4877C166.556 29.0599 167.933 29.3544 168.217 29.6266C175.833 31.5488 177.656 41.6933 181.178 40.8155C184.178 40.0655 186.156 43.2544 192.339 44.0266C198.489 44.7933 199.195 48.1099 203.806 47.2488C213.511 45.4433 221.628 45.0044 231.05 48.4322C230.567 47.6933 232.75 47.971 232.645 46.6155Z",
    fill: "url(#paint0_linear_8543_4027)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M217.078 27.6154C220.267 31.3099 223.556 35.0543 224.962 36.5821C224.962 35.0599 225.084 33.4321 225.139 32.0043C225.273 28.6599 225.134 26.821 225.167 21.1654C225.195 16.6765 224.639 11.6988 222.573 10.5321C220.656 9.4432 217.562 11.5599 213.167 15.5988C210.717 17.8543 209.106 19.7988 207.428 21.1877C209.428 21.9043 213.784 23.7988 217.078 27.6154Z",
    fill: "url(#paint1_linear_8543_4027)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M202.367 19.4822C202.011 18.0099 201.822 15.0766 200.795 10.7877C199.517 5.44883 197.784 2.83771 195.278 2.62104C193.167 2.44326 189.506 7.75993 186.684 12.2099C184.345 15.8933 184.172 16.271 183.261 17.5988C182.595 18.5655 181.834 19.7099 181.006 20.8599C183.422 20.4599 187.739 19.6877 191.967 18.9044C196.134 18.1266 200.011 18.8322 202.361 19.4822H202.367Z",
    fill: "url(#paint2_linear_8543_4027)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M231.05 48.4321C221.883 45.0988 213.867 45.4266 204.383 47.1488C203.428 47.321 202.65 47.4766 201.606 47.3432C203.728 49.6044 197.55 55.4488 190.206 54.0488C187.7 53.571 185.672 52.7988 184.056 51.8599C178.633 48.6988 178.017 43.6933 179.989 41.1433C180.078 41.0321 180.167 40.9155 180.267 40.7988C177.283 39.9377 175.15 31.3877 168.217 29.6377C168.278 29.6933 168.289 29.7488 168.217 29.8155C167.533 30.4599 164.645 29.2099 163.928 31.0821C163.345 32.6155 166.445 32.8933 166.217 33.6044C165.9 34.5766 163.678 34.3321 163.383 35.3099C162.889 36.9433 163.95 36.8433 166.656 39.2933C168.022 40.5266 169.8 42.4099 172.017 45.4877C175.539 50.3877 175.778 61.621 175.344 69.3377C175.128 73.1988 173.161 81.7821 172.939 86.3155C172.706 90.9766 173.194 95.171 173.311 98.8655C173.339 100.677 173.311 103.204 172.889 104.993C171.833 110.31 168.694 111.16 167.55 118.149C165.828 128.665 177.272 132.615 177.15 132.649C177.122 132.654 177.083 132.665 177.039 132.677C177.622 132.743 178.194 132.815 178.75 132.882C181.25 133.188 183.422 133.477 185.289 133.738C186.011 133.838 186.778 133.938 187.417 134.032C187.222 135.182 186.917 136.515 186.622 137.377C186.211 138.582 185.783 140.777 186.383 141.782C187.583 143.81 195.022 143.504 195.367 141.11C195.539 139.943 195.65 138.515 195.717 136.899C195.717 136.904 195.717 136.91 195.717 136.915C196.561 136.877 196.617 136.888 197.167 136.921C197.172 137.16 197.261 139.382 197.517 141.11C197.867 143.504 205.3 143.81 206.5 141.782C207.094 140.782 206.678 138.588 206.261 137.377C206.067 136.81 205.861 136.01 205.689 135.188C206.622 134.999 217.422 132.788 218.333 132.643C218.344 132.599 218.406 132.56 218.517 132.521C223.467 130.81 229.083 123.232 226.489 116.149C225.006 112.093 222.25 110.171 220.706 107.465C217.511 101.86 219.95 100.549 218.544 85.5877C217.933 79.071 216.222 71.3932 215.528 67.421C214.15 59.5321 215.933 59.5821 220.583 58.2877C226.583 56.6155 228.628 57.671 229.433 55.7933C229.817 54.9099 228.389 54.2877 228.7 53.3766C229.194 51.9488 233.2 53.1377 233.494 51.6544C233.872 49.7488 231.522 49.1488 231.056 48.4377L231.05 48.4321Z",
    fill: "url(#paint3_linear_8543_4027)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M231.05 48.4321C221.883 45.0988 213.867 45.4266 204.383 47.1488C203.428 47.321 202.65 47.4766 201.606 47.3432C203.728 49.6044 197.55 55.4488 190.206 54.0488C187.7 53.571 185.672 52.7988 184.056 51.8599C178.633 48.6988 178.017 43.6933 179.989 41.1433C180.078 41.0321 180.167 40.9155 180.267 40.7988C177.283 39.9377 175.15 31.3877 168.217 29.6377C168.278 29.6933 168.289 29.7488 168.217 29.8155C167.533 30.4599 164.645 29.2099 163.928 31.0821C163.345 32.6155 166.445 32.8933 166.217 33.6044C165.9 34.5766 163.678 34.3321 163.383 35.3099C162.889 36.9433 163.95 36.8433 166.656 39.2933C168.022 40.5266 169.8 42.4099 172.017 45.4877C175.539 50.3877 175.778 61.621 175.344 69.3377C175.128 73.1988 173.161 81.7821 172.939 86.3155C172.706 90.9766 173.194 95.171 173.311 98.8655C173.339 100.677 173.311 103.204 172.889 104.993C171.833 110.31 168.694 111.16 167.55 118.149C165.828 128.665 177.272 132.615 177.15 132.649C177.122 132.654 177.083 132.665 177.039 132.677C177.622 132.743 178.194 132.815 178.75 132.882C181.25 133.188 183.422 133.477 185.289 133.738C186.011 133.838 186.778 133.938 187.417 134.032C187.222 135.182 186.917 136.515 186.622 137.377C186.211 138.582 185.783 140.777 186.383 141.782C187.583 143.81 195.022 143.504 195.367 141.11C195.539 139.943 195.65 138.515 195.717 136.899C195.717 136.904 195.717 136.91 195.717 136.915C196.561 136.877 196.617 136.888 197.167 136.921C197.172 137.16 197.261 139.382 197.517 141.11C197.867 143.504 205.3 143.81 206.5 141.782C207.094 140.782 206.678 138.588 206.261 137.377C206.067 136.81 205.861 136.01 205.689 135.188C206.622 134.999 217.422 132.788 218.333 132.643C218.344 132.599 218.406 132.56 218.517 132.521C223.467 130.81 229.083 123.232 226.489 116.149C225.006 112.093 222.25 110.171 220.706 107.465C217.511 101.86 219.95 100.549 218.544 85.5877C217.933 79.071 216.222 71.3932 215.528 67.421C214.15 59.5321 215.933 59.5821 220.583 58.2877C226.583 56.6155 228.628 57.671 229.433 55.7933C229.817 54.9099 228.389 54.2877 228.7 53.3766C229.194 51.9488 233.2 53.1377 233.494 51.6544C233.872 49.7488 231.522 49.1488 231.056 48.4377L231.05 48.4321Z",
    fill: "url(#paint4_linear_8543_4027)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M185.384 133.738C183.517 133.477 181.345 133.188 178.845 132.882C178.289 132.816 177.723 132.743 177.134 132.677C176.417 132.827 173.473 133.305 171.328 135.927C170.567 136.855 170.311 137.582 170.306 138.182C170.306 138.582 170.411 138.927 170.567 139.227C171.273 140.599 174.706 140.466 176.689 139.938C177.811 139.638 179.267 139.305 180.884 138.982C182.645 138.632 184.595 138.293 186.517 138.027C186.578 137.81 186.639 137.593 186.717 137.377C187 136.549 187.311 135.221 187.506 134.049C186.85 133.949 186.134 133.849 185.378 133.738H185.384Z",
    fill: "url(#paint5_linear_8543_4027)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M223.35 136.227C222.9 135.677 222.123 135.055 220.861 134.321C219.261 133.394 217.834 132.983 218.028 132.699C217.773 132.738 217.517 132.783 217.25 132.838C211.828 133.938 208.184 134.571 205.723 134.927C205.906 135.844 206.139 136.755 206.35 137.377C206.423 137.588 206.489 137.799 206.545 138.01C206.567 138.099 206.589 138.188 206.611 138.277C211.345 138.999 213.428 139.894 217.234 140.088C221.495 140.305 222.817 139.877 223.539 138.599C223.928 137.905 224.123 137.171 223.35 136.227Z",
    fill: "url(#paint6_linear_8543_4027)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M187.344 119.31C185.528 112.416 179.939 107.043 172.906 105.488C172.806 105.927 172.678 106.349 172.533 106.766C172.533 106.782 172.522 106.793 172.517 106.81C172.306 107.421 172.061 108.016 171.744 108.582C170.189 111.404 168.422 113.377 167.644 118.154C165.922 128.671 177.367 132.621 177.244 132.654C177.217 132.66 177.178 132.671 177.133 132.682C177.717 132.749 178.289 132.821 178.844 132.888C181.344 133.193 183.517 133.482 185.383 133.743C186.589 131.677 187.417 129.366 187.772 126.899C187.706 124.588 187.556 122.004 187.344 119.31Z",
    fill: "url(#paint7_radial_8543_4027)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M194.961 112.316C194.589 112.76 194.367 115.677 193.889 115.921C193.506 116.116 193.317 113.632 192.922 111.393C192.817 110.788 192.406 108.827 192.3 108.244C191.8 105.438 191.795 105.66 191.378 103.371C191.295 105.199 191.128 105.688 190.795 108.488C190.634 109.849 190.4 111.482 190.211 112.388C190.045 113.177 189.783 110.238 189.628 109.466C188.85 105.716 188.306 104.71 187.256 100.977C186.661 98.8657 184.8 96.9157 184.617 95.5713C185.467 101.332 186.695 110.866 187.356 119.316C187.567 122.005 187.717 124.588 187.783 126.905C187.845 129.127 187.828 131.11 187.7 132.699C187.667 133.094 187.606 133.56 187.522 134.06C187.328 135.232 187.017 136.56 186.734 137.388C186.661 137.605 186.595 137.821 186.533 138.038C186.1 139.638 186.1 141.127 186.495 141.793C187.695 143.821 195.134 143.516 195.478 141.121C195.65 139.949 195.761 138.521 195.828 136.899C196.078 130.788 195.65 121.81 194.972 112.321L194.961 112.316Z",
    fill: "url(#paint8_linear_8543_4027)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M206.55 138.01C206.495 137.799 206.428 137.588 206.356 137.377C206.139 136.749 205.911 135.838 205.728 134.927C205.567 134.121 205.434 133.31 205.384 132.694C204.711 124.255 207.078 104.932 208.467 95.5713C208.284 96.9213 206.423 98.8657 205.828 100.977C204.778 104.71 204.234 105.716 203.456 109.466C203.295 110.243 203.039 113.182 202.873 112.388C202.678 111.482 202.45 109.849 202.289 108.488C201.956 105.682 201.789 105.199 201.706 103.371C201.289 105.66 201.289 105.444 200.784 108.244C200.678 108.821 200.273 110.782 200.162 111.393C199.767 113.638 199.578 116.116 199.195 115.921C198.712 115.677 198.495 112.76 198.123 112.316C197.445 121.799 197.017 130.777 197.267 136.888C197.334 138.51 197.445 139.943 197.617 141.116C197.967 143.51 205.4 143.816 206.6 141.788C206.973 141.155 206.989 139.782 206.623 138.277C206.6 138.188 206.584 138.099 206.556 138.01H206.55Z",
    fill: "url(#paint9_linear_8543_4027)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M195.795 67.6877C195.795 67.6877 187.922 73.5044 190.045 87.0932C191.745 97.9766 193.133 100.493 194.206 107.399C195.278 114.304 196.422 122.277 196.422 122.277C196.422 122.277 197.389 114.565 198.689 107.221C199.617 101.971 201.478 94.9043 202.478 86.4099C204.083 72.7321 195.795 67.6821 195.795 67.6821V67.6877Z",
    fill: "url(#paint10_linear_8543_4027)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M188.084 37.1661C192.6 37.7716 195.811 44.7439 200.834 46.8272C204.845 48.4883 198.217 55.5828 190.211 54.0494C179.428 51.9939 177.361 44.5494 179.995 41.1439C181.406 39.3161 184.295 36.655 188.084 37.1661Z",
    fill: "#FFC635"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M187.945 38.2878C186.334 37.7601 185.211 38.1656 184.723 38.7323C184.123 39.4267 184.211 41.3156 186.189 41.9656C188.067 42.5823 189.706 41.3767 189.778 40.4156C189.828 39.7323 189.361 38.7489 187.939 38.2878H187.945Z",
    fill: "#00073A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M206.328 34.0379C208.267 34.5824 208.928 36.2213 207.178 39.7991C205.806 42.6102 204.584 42.4824 202.761 41.9435C201.806 41.6602 200.661 40.1991 201.7 38.0546C203.117 35.1268 204.3 33.4713 206.328 34.0435V34.0379Z",
    fill: "url(#paint11_linear_8543_4027)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M203.607 39.4846C203.838 39.0001 203.665 38.4347 203.219 38.2219C202.773 38.0091 202.224 38.2294 201.993 38.7139C201.761 39.1985 201.935 39.7638 202.381 39.9767C202.827 40.1895 203.376 39.9692 203.607 39.4846Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M190.261 27.3602C192.817 27.9547 192.533 30.188 190.783 33.4991C189.689 35.5713 188.5 35.5213 186.683 34.9824C185.733 34.7047 184.472 33.6658 185.956 30.8269C187.156 28.5213 188.656 26.9824 190.267 27.3602H190.261Z",
    fill: "url(#paint12_linear_8543_4027)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M187.845 32.8493C188.082 32.3509 187.905 31.7701 187.448 31.5519C186.991 31.3338 186.428 31.5611 186.19 32.0595C185.952 32.5579 186.13 33.1387 186.587 33.3568C187.043 33.5749 187.607 33.3477 187.845 32.8493Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_8543_4027)"
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8315 24C40.8315 17.3726 46.2041 12 52.8315 12H164.832C171.459 12 176.832 17.3726 176.832 24V136C176.832 142.627 171.459 148 164.832 148H52.8315C46.2041 148 40.8315 142.627 40.8315 136V24Z",
    fill: "white",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8543_4027)"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M160.832 28H56.8315V132H160.832V28Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9781 31.25H90.3402V34.6121H86.9781V31.25ZM90.3402 31.25H93.7022V34.6121H90.3402V31.25ZM93.7022 31.25H97.0643V34.6121H93.7022V31.25ZM97.0643 31.25H100.426V34.6121H97.0643V31.25ZM100.426 31.25H103.788V34.6121H100.426V31.25ZM103.788 31.25H107.151V34.6121H103.788V31.25ZM107.151 31.25H110.513V34.6121H107.151V31.25ZM110.513 31.25H113.875V34.6121H110.513V31.25ZM113.875 31.25H117.237V34.6121H113.875V31.25ZM120.599 31.25H123.961V34.6121H120.599V31.25ZM123.961 31.25H127.323V34.6121H123.961V31.25ZM86.9781 34.6121H90.3402V37.9741H86.9781V34.6121ZM90.3402 34.6121H93.7022V37.9741H90.3402V34.6121ZM103.788 34.6121H107.151V37.9741H103.788V34.6121ZM113.875 34.6121H117.237V37.9741H113.875V34.6121ZM117.237 34.6121H120.599V37.9741H117.237V34.6121ZM123.961 34.6121H127.323V37.9741H123.961V34.6121ZM86.9781 37.9741H90.3402V41.3362H86.9781V37.9741ZM90.3402 37.9741H93.7022V41.3362H90.3402V37.9741ZM97.0643 37.9741H100.426V41.3362H97.0643V37.9741ZM107.151 37.9741H110.513V41.3362H107.151V37.9741ZM120.599 37.9741H123.961V41.3362H120.599V37.9741ZM127.323 37.9741H130.685V41.3362H127.323V37.9741ZM86.9781 41.3362H90.3402V44.6983H86.9781V41.3362ZM97.0643 41.3362H100.426V44.6983H97.0643V41.3362ZM103.788 41.3362H107.151V44.6983H103.788V41.3362ZM107.151 41.3362H110.513V44.6983H107.151V41.3362ZM113.875 41.3362H117.237V44.6983H113.875V41.3362ZM127.323 41.3362H130.685V44.6983H127.323V41.3362ZM86.9781 44.6983H90.3402V48.0603H86.9781V44.6983ZM90.3402 44.6983H93.7022V48.0603H90.3402V44.6983ZM93.7022 44.6983H97.0643V48.0603H93.7022V44.6983ZM103.788 44.6983H107.151V48.0603H103.788V44.6983ZM107.151 44.6983H110.513V48.0603H107.151V44.6983ZM110.513 44.6983H113.875V48.0603H110.513V44.6983ZM113.875 44.6983H117.237V48.0603H113.875V44.6983ZM120.599 44.6983H123.961V48.0603H120.599V44.6983ZM123.961 44.6983H127.323V48.0603H123.961V44.6983ZM93.7022 48.0603H97.0643V51.4224H93.7022V48.0603ZM97.0643 48.0603H100.426V51.4224H97.0643V48.0603ZM100.426 48.0603H103.788V51.4224H100.426V48.0603ZM103.788 48.0603H107.151V51.4224H103.788V48.0603ZM107.151 48.0603H110.513V51.4224H107.151V48.0603ZM110.513 48.0603H113.875V51.4224H110.513V48.0603ZM113.875 48.0603H117.237V51.4224H113.875V48.0603ZM120.599 48.0603H123.961V51.4224H120.599V48.0603ZM123.961 48.0603H127.323V51.4224H123.961V48.0603ZM86.9781 51.4224H90.3402V54.7845H86.9781V51.4224ZM93.7022 51.4224H97.0643V54.7845H93.7022V51.4224ZM100.426 51.4224H103.788V54.7845H100.426V51.4224ZM107.151 51.4224H110.513V54.7845H107.151V51.4224ZM113.875 51.4224H117.237V54.7845H113.875V51.4224ZM120.599 51.4224H123.961V54.7845H120.599V51.4224ZM127.323 51.4224H130.685V54.7845H127.323V51.4224ZM86.9781 54.7845H90.3402V58.1466H86.9781V54.7845ZM90.3402 54.7845H93.7022V58.1466H90.3402V54.7845ZM93.7022 54.7845H97.0643V58.1466H93.7022V54.7845ZM103.788 54.7845H107.151V58.1466H103.788V54.7845ZM107.151 54.7845H110.513V58.1466H107.151V54.7845ZM110.513 54.7845H113.875V58.1466H110.513V54.7845ZM113.875 54.7845H117.237V58.1466H113.875V54.7845ZM117.237 54.7845H120.599V58.1466H117.237V54.7845ZM123.961 54.7845H127.323V58.1466H123.961V54.7845ZM63.4436 58.1466H66.8057V61.5086H63.4436V58.1466ZM66.8057 58.1466H70.1678V61.5086H66.8057V58.1466ZM73.5298 58.1466H76.8919V61.5086H73.5298V58.1466ZM80.254 58.1466H83.616V61.5086H80.254V58.1466ZM83.616 58.1466H86.9781V61.5086H83.616V58.1466ZM93.7022 58.1466H97.0643V61.5086H93.7022V58.1466ZM97.0643 58.1466H100.426V61.5086H97.0643V58.1466ZM100.426 58.1466H103.788V61.5086H100.426V58.1466ZM103.788 58.1466H107.151V61.5086H103.788V58.1466ZM107.151 58.1466H110.513V61.5086H107.151V58.1466ZM113.875 58.1466H117.237V61.5086H113.875V58.1466ZM117.237 58.1466H120.599V61.5086H117.237V58.1466ZM134.047 58.1466H137.409V61.5086H134.047V58.1466ZM140.771 58.1466H144.133V61.5086H140.771V58.1466ZM144.133 58.1466H147.495V61.5086H144.133V58.1466ZM147.495 58.1466H150.857V61.5086H147.495V58.1466ZM150.857 58.1466H154.219V61.5086H150.857V58.1466ZM154.219 58.1466H157.582V61.5086H154.219V58.1466ZM60.0815 61.5086H63.4436V64.8707H60.0815V61.5086ZM70.1678 61.5086H73.5298V64.8707H70.1678V61.5086ZM73.5298 61.5086H76.8919V64.8707H73.5298V61.5086ZM76.8919 61.5086H80.254V64.8707H76.8919V61.5086ZM86.9781 61.5086H90.3402V64.8707H86.9781V61.5086ZM100.426 61.5086H103.788V64.8707H100.426V61.5086ZM110.513 61.5086H113.875V64.8707H110.513V61.5086ZM120.599 61.5086H123.961V64.8707H120.599V61.5086ZM130.685 61.5086H134.047V64.8707H130.685V61.5086ZM134.047 61.5086H137.409V64.8707H134.047V61.5086ZM137.409 61.5086H140.771V64.8707H137.409V61.5086ZM154.219 61.5086H157.582V64.8707H154.219V61.5086ZM66.8057 64.8707H70.1678V68.2328H66.8057V64.8707ZM73.5298 64.8707H76.8919V68.2328H73.5298V64.8707ZM80.254 64.8707H83.616V68.2328H80.254V64.8707ZM90.3402 64.8707H93.7022V68.2328H90.3402V64.8707ZM93.7022 64.8707H97.0643V68.2328H93.7022V64.8707ZM97.0643 64.8707H100.426V68.2328H97.0643V64.8707ZM103.788 64.8707H107.151V68.2328H103.788V64.8707ZM107.151 64.8707H110.513V68.2328H107.151V64.8707ZM110.513 64.8707H113.875V68.2328H110.513V64.8707ZM117.237 64.8707H120.599V68.2328H117.237V64.8707ZM127.323 64.8707H130.685V68.2328H127.323V64.8707ZM137.409 64.8707H140.771V68.2328H137.409V64.8707ZM140.771 64.8707H144.133V68.2328H140.771V64.8707ZM147.495 64.8707H150.857V68.2328H147.495V64.8707ZM150.857 64.8707H154.219V68.2328H150.857V64.8707ZM154.219 64.8707H157.582V68.2328H154.219V64.8707ZM73.5298 68.2328H76.8919V71.5948H73.5298V68.2328ZM86.9781 68.2328H90.3402V71.5948H86.9781V68.2328ZM93.7022 68.2328H97.0643V71.5948H93.7022V68.2328ZM100.426 68.2328H103.788V71.5948H100.426V68.2328ZM103.788 68.2328H107.151V71.5948H103.788V68.2328ZM110.513 68.2328H113.875V71.5948H110.513V68.2328ZM113.875 68.2328H117.237V71.5948H113.875V68.2328ZM117.237 68.2328H120.599V71.5948H117.237V68.2328ZM123.961 68.2328H127.323V71.5948H123.961V68.2328ZM130.685 68.2328H134.047V71.5948H130.685V68.2328ZM134.047 68.2328H137.409V71.5948H134.047V68.2328ZM140.771 68.2328H144.133V71.5948H140.771V68.2328ZM144.133 68.2328H147.495V71.5948H144.133V68.2328ZM150.857 68.2328H154.219V71.5948H150.857V68.2328ZM60.0815 71.5948H63.4436V74.9569H60.0815V71.5948ZM66.8057 71.5948H70.1678V74.9569H66.8057V71.5948ZM73.5298 71.5948H76.8919V74.9569H73.5298V71.5948ZM80.254 71.5948H83.616V74.9569H80.254V71.5948ZM86.9781 71.5948H90.3402V74.9569H86.9781V71.5948ZM103.788 71.5948H107.151V74.9569H103.788V71.5948ZM113.875 71.5948H117.237V74.9569H113.875V71.5948ZM117.237 71.5948H120.599V74.9569H117.237V71.5948ZM134.047 71.5948H137.409V74.9569H134.047V71.5948ZM137.409 71.5948H140.771V74.9569H137.409V71.5948ZM60.0815 74.9569H63.4436V78.319H60.0815V74.9569ZM63.4436 74.9569H66.8057V78.319H63.4436V74.9569ZM70.1678 74.9569H73.5298V78.319H70.1678V74.9569ZM76.8919 74.9569H80.254V78.319H76.8919V74.9569ZM93.7022 74.9569H97.0643V78.319H93.7022V74.9569ZM97.0643 74.9569H100.426V78.319H97.0643V74.9569ZM100.426 74.9569H103.788V78.319H100.426V74.9569ZM103.788 74.9569H107.151V78.319H103.788V74.9569ZM110.513 74.9569H113.875V78.319H110.513V74.9569ZM117.237 74.9569H120.599V78.319H117.237V74.9569ZM127.323 74.9569H130.685V78.319H127.323V74.9569ZM130.685 74.9569H134.047V78.319H130.685V74.9569ZM134.047 74.9569H137.409V78.319H134.047V74.9569ZM137.409 74.9569H140.771V78.319H137.409V74.9569ZM154.219 74.9569H157.582V78.319H154.219V74.9569ZM70.1678 78.319H73.5298V81.681H70.1678V78.319ZM73.5298 78.319H76.8919V81.681H73.5298V78.319ZM80.254 78.319H83.616V81.681H80.254V78.319ZM90.3402 78.319H93.7022V81.681H90.3402V78.319ZM100.426 78.319H103.788V81.681H100.426V78.319ZM103.788 78.319H107.151V81.681H103.788V78.319ZM107.151 78.319H110.513V81.681H107.151V78.319ZM110.513 78.319H113.875V81.681H110.513V78.319ZM120.599 78.319H123.961V81.681H120.599V78.319ZM130.685 78.319H134.047V81.681H130.685V78.319ZM137.409 78.319H140.771V81.681H137.409V78.319ZM147.495 78.319H150.857V81.681H147.495V78.319ZM150.857 78.319H154.219V81.681H150.857V78.319ZM154.219 78.319H157.582V81.681H154.219V78.319ZM76.8919 81.681H80.254V85.0431H76.8919V81.681ZM83.616 81.681H86.9781V85.0431H83.616V81.681ZM86.9781 81.681H90.3402V85.0431H86.9781V81.681ZM90.3402 81.681H93.7022V85.0431H90.3402V81.681ZM93.7022 81.681H97.0643V85.0431H93.7022V81.681ZM107.151 81.681H110.513V85.0431H107.151V81.681ZM110.513 81.681H113.875V85.0431H110.513V81.681ZM113.875 81.681H117.237V85.0431H113.875V81.681ZM117.237 81.681H120.599V85.0431H117.237V81.681ZM120.599 81.681H123.961V85.0431H120.599V81.681ZM123.961 81.681H127.323V85.0431H123.961V81.681ZM134.047 81.681H137.409V85.0431H134.047V81.681ZM137.409 81.681H140.771V85.0431H137.409V81.681ZM154.219 81.681H157.582V85.0431H154.219V81.681ZM63.4436 85.0431H66.8057V88.4052H63.4436V85.0431ZM66.8057 85.0431H70.1678V88.4052H66.8057V85.0431ZM73.5298 85.0431H76.8919V88.4052H73.5298V85.0431ZM80.254 85.0431H83.616V88.4052H80.254V85.0431ZM83.616 85.0431H86.9781V88.4052H83.616V85.0431ZM90.3402 85.0431H93.7022V88.4052H90.3402V85.0431ZM103.788 85.0431H107.151V88.4052H103.788V85.0431ZM107.151 85.0431H110.513V88.4052H107.151V85.0431ZM113.875 85.0431H117.237V88.4052H113.875V85.0431ZM117.237 85.0431H120.599V88.4052H117.237V85.0431ZM134.047 85.0431H137.409V88.4052H134.047V85.0431ZM144.133 85.0431H147.495V88.4052H144.133V85.0431ZM154.219 85.0431H157.582V88.4052H154.219V85.0431ZM63.4436 88.4052H66.8057V91.7672H63.4436V88.4052ZM70.1678 88.4052H73.5298V91.7672H70.1678V88.4052ZM73.5298 88.4052H76.8919V91.7672H73.5298V88.4052ZM83.616 88.4052H86.9781V91.7672H83.616V88.4052ZM93.7022 88.4052H97.0643V91.7672H93.7022V88.4052ZM110.513 88.4052H113.875V91.7672H110.513V88.4052ZM113.875 88.4052H117.237V91.7672H113.875V88.4052ZM117.237 88.4052H120.599V91.7672H117.237V88.4052ZM127.323 88.4052H130.685V91.7672H127.323V88.4052ZM134.047 88.4052H137.409V91.7672H134.047V88.4052ZM147.495 88.4052H150.857V91.7672H147.495V88.4052ZM150.857 88.4052H154.219V91.7672H150.857V88.4052ZM154.219 88.4052H157.582V91.7672H154.219V88.4052ZM60.0815 91.7672H63.4436V95.1293H60.0815V91.7672ZM70.1678 91.7672H73.5298V95.1293H70.1678V91.7672ZM76.8919 91.7672H80.254V95.1293H76.8919V91.7672ZM80.254 91.7672H83.616V95.1293H80.254V91.7672ZM100.426 91.7672H103.788V95.1293H100.426V91.7672ZM107.151 91.7672H110.513V95.1293H107.151V91.7672ZM110.513 91.7672H113.875V95.1293H110.513V91.7672ZM113.875 91.7672H117.237V95.1293H113.875V91.7672ZM120.599 91.7672H123.961V95.1293H120.599V91.7672ZM130.685 91.7672H134.047V95.1293H130.685V91.7672ZM137.409 91.7672H140.771V95.1293H137.409V91.7672ZM150.857 91.7672H154.219V95.1293H150.857V91.7672ZM154.219 91.7672H157.582V95.1293H154.219V91.7672ZM63.4436 95.1293H66.8057V98.4914H63.4436V95.1293ZM66.8057 95.1293H70.1678V98.4914H66.8057V95.1293ZM73.5298 95.1293H76.8919V98.4914H73.5298V95.1293ZM83.616 95.1293H86.9781V98.4914H83.616V95.1293ZM90.3402 95.1293H93.7022V98.4914H90.3402V95.1293ZM100.426 95.1293H103.788V98.4914H100.426V95.1293ZM103.788 95.1293H107.151V98.4914H103.788V95.1293ZM107.151 95.1293H110.513V98.4914H107.151V95.1293ZM113.875 95.1293H117.237V98.4914H113.875V95.1293ZM117.237 95.1293H120.599V98.4914H117.237V95.1293ZM120.599 95.1293H123.961V98.4914H120.599V95.1293ZM123.961 95.1293H127.323V98.4914H123.961V95.1293ZM134.047 95.1293H137.409V98.4914H134.047V95.1293ZM140.771 95.1293H144.133V98.4914H140.771V95.1293ZM154.219 95.1293H157.582V98.4914H154.219V95.1293ZM60.0815 98.4914H63.4436V101.853H60.0815V98.4914ZM76.8919 98.4914H80.254V101.853H76.8919V98.4914ZM80.254 98.4914H83.616V101.853H80.254V98.4914ZM83.616 98.4914H86.9781V101.853H83.616V98.4914ZM90.3402 98.4914H93.7022V101.853H90.3402V98.4914ZM100.426 98.4914H103.788V101.853H100.426V98.4914ZM103.788 98.4914H107.151V101.853H103.788V98.4914ZM107.151 98.4914H110.513V101.853H107.151V98.4914ZM110.513 98.4914H113.875V101.853H110.513V98.4914ZM117.237 98.4914H120.599V101.853H117.237V98.4914ZM123.961 98.4914H127.323V101.853H123.961V98.4914ZM127.323 98.4914H130.685V101.853H127.323V98.4914ZM130.685 98.4914H134.047V101.853H130.685V98.4914ZM134.047 98.4914H137.409V101.853H134.047V98.4914ZM137.409 98.4914H140.771V101.853H137.409V98.4914ZM140.771 98.4914H144.133V101.853H140.771V98.4914ZM150.857 98.4914H154.219V101.853H150.857V98.4914ZM86.9781 101.853H90.3402V105.216H86.9781V101.853ZM90.3402 101.853H93.7022V105.216H90.3402V101.853ZM97.0643 101.853H100.426V105.216H97.0643V101.853ZM113.875 101.853H117.237V105.216H113.875V101.853ZM117.237 101.853H120.599V105.216H117.237V101.853ZM123.961 101.853H127.323V105.216H123.961V101.853ZM127.323 101.853H130.685V105.216H127.323V101.853ZM140.771 101.853H144.133V105.216H140.771V101.853ZM154.219 101.853H157.582V105.216H154.219V101.853ZM86.9781 105.216H90.3402V108.578H86.9781V105.216ZM93.7022 105.216H97.0643V108.578H93.7022V105.216ZM97.0643 105.216H100.426V108.578H97.0643V105.216ZM100.426 105.216H103.788V108.578H100.426V105.216ZM103.788 105.216H107.151V108.578H103.788V105.216ZM113.875 105.216H117.237V108.578H113.875V105.216ZM117.237 105.216H120.599V108.578H117.237V105.216ZM123.961 105.216H127.323V108.578H123.961V105.216ZM127.323 105.216H130.685V108.578H127.323V105.216ZM134.047 105.216H137.409V108.578H134.047V105.216ZM140.771 105.216H144.133V108.578H140.771V105.216ZM147.495 105.216H150.857V108.578H147.495V105.216ZM150.857 105.216H154.219V108.578H150.857V105.216ZM154.219 105.216H157.582V108.578H154.219V105.216ZM107.151 108.578H110.513V111.94H107.151V108.578ZM117.237 108.578H120.599V111.94H117.237V108.578ZM127.323 108.578H130.685V111.94H127.323V108.578ZM140.771 108.578H144.133V111.94H140.771V108.578ZM86.9781 111.94H90.3402V115.302H86.9781V111.94ZM90.3402 111.94H93.7022V115.302H90.3402V111.94ZM93.7022 111.94H97.0643V115.302H93.7022V111.94ZM97.0643 111.94H100.426V115.302H97.0643V111.94ZM103.788 111.94H107.151V115.302H103.788V111.94ZM110.513 111.94H113.875V115.302H110.513V111.94ZM113.875 111.94H117.237V115.302H113.875V111.94ZM117.237 111.94H120.599V115.302H117.237V111.94ZM120.599 111.94H123.961V115.302H120.599V111.94ZM127.323 111.94H130.685V115.302H127.323V111.94ZM130.685 111.94H134.047V115.302H130.685V111.94ZM134.047 111.94H137.409V115.302H134.047V111.94ZM137.409 111.94H140.771V115.302H137.409V111.94ZM140.771 111.94H144.133V115.302H140.771V111.94ZM144.133 111.94H147.495V115.302H144.133V111.94ZM150.857 111.94H154.219V115.302H150.857V111.94ZM154.219 111.94H157.582V115.302H154.219V111.94ZM93.7022 115.302H97.0643V118.664H93.7022V115.302ZM97.0643 115.302H100.426V118.664H97.0643V115.302ZM103.788 115.302H107.151V118.664H103.788V115.302ZM107.151 115.302H110.513V118.664H107.151V115.302ZM110.513 115.302H113.875V118.664H110.513V115.302ZM117.237 115.302H120.599V118.664H117.237V115.302ZM120.599 115.302H123.961V118.664H120.599V115.302ZM127.323 115.302H130.685V118.664H127.323V115.302ZM130.685 115.302H134.047V118.664H130.685V115.302ZM140.771 115.302H144.133V118.664H140.771V115.302ZM144.133 115.302H147.495V118.664H144.133V115.302ZM86.9781 118.664H90.3402V122.026H86.9781V118.664ZM97.0643 118.664H100.426V122.026H97.0643V118.664ZM113.875 118.664H117.237V122.026H113.875V118.664ZM123.961 118.664H127.323V122.026H123.961V118.664ZM137.409 118.664H140.771V122.026H137.409V118.664ZM140.771 118.664H144.133V122.026H140.771V118.664ZM144.133 118.664H147.495V122.026H144.133V118.664ZM154.219 118.664H157.582V122.026H154.219V118.664ZM86.9781 122.026H90.3402V125.388H86.9781V122.026ZM90.3402 122.026H93.7022V125.388H90.3402V122.026ZM93.7022 122.026H97.0643V125.388H93.7022V122.026ZM97.0643 122.026H100.426V125.388H97.0643V122.026ZM100.426 122.026H103.788V125.388H100.426V122.026ZM110.513 122.026H113.875V125.388H110.513V122.026ZM117.237 122.026H120.599V125.388H117.237V122.026ZM127.323 122.026H130.685V125.388H127.323V122.026ZM130.685 122.026H134.047V125.388H130.685V122.026ZM137.409 122.026H140.771V125.388H137.409V122.026ZM150.857 122.026H154.219V125.388H150.857V122.026ZM90.3402 125.388H93.7022V128.75H90.3402V125.388ZM107.151 125.388H110.513V128.75H107.151V125.388ZM110.513 125.388H113.875V128.75H110.513V125.388ZM113.875 125.388H117.237V128.75H113.875V125.388ZM117.237 125.388H120.599V128.75H117.237V125.388ZM123.961 125.388H127.323V128.75H123.961V125.388ZM127.323 125.388H130.685V128.75H127.323V125.388ZM130.685 125.388H134.047V128.75H130.685V125.388ZM134.047 125.388H137.409V128.75H134.047V125.388ZM140.771 125.388H144.133V128.75H140.771V125.388ZM150.857 125.388H154.219V128.75H150.857V125.388ZM154.219 125.388H157.582V128.75H154.219V125.388Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8919 37.9741H66.8057V48.0603H76.8919V37.9741Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8543_4027",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 31,
    width: 24,
    height: 24
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M83.616 31.25H60.0815V54.7845H83.616V31.25Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2539 34.6123H63.4436V51.4226H80.2539V34.6123Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8543_4027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.616 31.25H60.0815V54.7845H83.616V31.25Z",
    fill: "black"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M150.857 37.9741H140.771V48.0603H150.857V37.9741Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8543_4027",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 134,
    y: 31,
    width: 24,
    height: 24
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M157.582 31.25H134.047V54.7845H157.582V31.25Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M154.22 34.6123H137.409V51.4226H154.22V34.6123Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8543_4027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.582 31.25H134.047V54.7845H157.582V31.25Z",
    fill: "black"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8919 111.939H66.8057V122.026H76.8919V111.939Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8543_4027",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 105,
    width: 24,
    height: 24
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M83.616 105.215H60.0815V128.75H83.616V105.215Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2539 108.577H63.4436V125.387H80.2539V108.577Z",
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8543_4027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.616 105.215H60.0815V128.75H83.616V105.215Z",
    fill: "black"
  }))))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M40.76 135.376C40.76 135.376 34.475 135.351 30.025 133.891C15.395 129.101 7.43 119.966 2.475 109.251C0.714998 105.451 0 98.9857 0 98.9857C0 98.9857 1.065 99.9757 2.515 101.111C3.665 102.011 4.5 102.306 4.5 102.306C4.5 102.306 3.57 100.276 2.995 97.3107C0.954995 86.8157 3.34999 79.2357 7.89999 71.3907C14.185 60.5557 20.335 56.1707 23.4 47.5157C24.495 44.4157 24.8 41.9207 24.03 39.5507C23.11 36.7107 17.585 34.5757 17.585 34.5757C17.585 34.5757 25.62 31.9607 35.3 37.0407C40.865 39.9607 45.79 43.7357 48.7 47.9957C55.935 58.5857 56.86 65.3607 54.845 78.0957C52.935 90.1507 45.22 100.276 42.345 105.416C41.845 106.311 40.765 109.301 40.765 109.871V135.371L40.76 135.376Z",
    fill: "url(#paint13_linear_8543_4027)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M47.9753 61.6954C46.6353 56.8004 45.8103 55.4304 43.0353 51.1804C41.1653 48.3104 39.3553 47.0904 39.3553 47.0904L40.6403 50.9554L41.5653 54.6104C42.0853 54.9504 39.9553 52.0904 36.6803 48.8504C34.3803 46.5754 30.8403 45.0454 30.8403 45.0454C30.8403 45.0454 33.8203 49.3504 35.7303 53.5904C37.6403 57.8304 38.4803 66.7204 38.0503 69.3504C37.2753 74.1004 43.8103 72.2954 46.6803 72.8154C49.5503 73.3354 49.3253 69.4454 47.9703 61.6854L47.9753 61.6954Z",
    fill: "url(#paint14_linear_8543_4027)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7604 123.446C39.3504 122.736 37.9654 121.966 36.6354 121.126C33.0004 118.831 30.1004 116.376 27.1854 112.636C25.7904 110.846 23.7754 106.661 23.7754 106.661C23.7754 106.661 27.7454 110.821 30.1104 112.461C32.0904 113.831 36.5504 115.571 36.5504 115.571C36.5504 115.571 33.0754 112.831 31.5804 111.316C27.9954 107.676 25.3603 103.511 23.6153 99.0257C20.9604 92.1907 20.3704 84.6157 21.6454 77.0357C22.1354 74.1307 23.9154 68.3657 23.9154 68.3657C23.9154 68.3657 18.4904 73.5357 16.4754 78.5407C13.8604 85.0457 14.1954 92.7857 14.1954 92.7857C14.1954 92.7857 12.6454 90.2457 11.9404 88.7957C11.2904 87.4607 10.6204 84.4557 10.6204 84.4557C10.6204 84.4557 9.64036 88.2907 9.59036 92.6807C9.50036 100.631 10.6304 106.831 14.4804 113.681C17.6504 119.311 25.5954 125.506 34.4954 129.346C36.4104 130.171 38.5654 130.696 40.7504 131.056V123.451L40.7604 123.446Z",
    fill: "url(#paint15_radial_8543_4027)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_8543_4027",
    x: 24.8315,
    y: 0,
    width: 168,
    height: 168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8543_4027"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8543_4027",
    result: "effect2_dropShadow_8543_4027"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8543_4027",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8543_4027",
    x1: 211.667,
    y1: 1.75993,
    x2: 189.472,
    y2: 69.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FF9C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF6700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8543_4027",
    x1: 217.671,
    y1: 26.6379,
    x2: 229.534,
    y2: 7.85066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FF6600",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FF6600",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FF6600",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF6600",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FD4737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB2872"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8543_4027",
    x1: 191.791,
    y1: 18.5601,
    x2: 194.428,
    y2: -3.54826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FF6600",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FF6600",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FF6600",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FF6600",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FF6600",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FF6600",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FF6600",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF6600",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FD4737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#FB2872"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8543_4027",
    x1: 198.4,
    y1: 27.5544,
    x2: 198.4,
    y2: 150.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FF7408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FF8A14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FF9B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFA724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFAE27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FFB029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FF9218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FE5D0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FD4A32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FC3B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FB3062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FB2A6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FB2872"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8543_4027",
    x1: 198.4,
    y1: 27.5544,
    x2: 198.4,
    y2: 150.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB49",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FFD13A",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF8F17",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8543_4027",
    x1: 226.356,
    y1: 117.482,
    x2: 151.645,
    y2: 147.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#BE0449",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FB2872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#A31C5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#4C104A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#15093E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00073A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8543_4027",
    x1: 184.5,
    y1: 124.61,
    x2: 235.484,
    y2: 144.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE0449",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FB2872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00073A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_8543_4027",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(168.828 126.777) scale(31.6445 31.6444)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFE546",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFD73E",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFC031",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FFA01F",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF7709",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FF6600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8543_4027",
    x1: 189.578,
    y1: 96.3213,
    x2: 191.75,
    y2: 154.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#BE0449",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#BF054A",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#C2084C",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#C70D51",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#CE1457",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#D71E5F",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D81F60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D31E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C71D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B31A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#971754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#73134E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#460E46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#13093D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00073A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8543_4027",
    x1: 203.773,
    y1: 85.7324,
    x2: 201.373,
    y2: 154.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81F60",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D81F60",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D81F60",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#D81F60",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D81F60",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D81F60",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D81F60",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D81F60",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#D81F60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#D21E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C21C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#A81957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#841551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#551049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#1D0A3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00073A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8543_4027",
    x1: 196.022,
    y1: 79.2932,
    x2: 198.367,
    y2: 130.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFE745",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FFDE3D",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFCF2F",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFBB1C",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FFA105",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8543_4027",
    x1: 206.506,
    y1: 31.2602,
    x2: 203.711,
    y2: 42.0991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A030B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#00073A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_8543_4027",
    x1: 190.544,
    y1: 25.2102,
    x2: 187.839,
    y2: 34.2658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A030B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#00073A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_8543_4027",
    x1: 27.885,
    y1: 33.9107,
    x2: 27.885,
    y2: 135.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FF9B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FD4835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FB3161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB2872"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_8543_4027",
    x1: 31.1565,
    y1: 44.4384,
    x2: 43.9861,
    y2: 66.9293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FFEB49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFEB49",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEB49",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEB49",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FFEB49",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#FFEB49",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEB49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_8543_4027",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-61.6946 85.2507) scale(95.455 95.455)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE0449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB2872",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8543_4027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white",
    transform: "translate(56.8315 28)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQrMobileKit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/qr-mobile-kit.85d257c2855ef11e55e5cc09ffa1f2e8.svg";